import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => navigate("/admin", { replace: true, state: { user: r.data } }))
      .catch((e) => {
        window.history.replaceState(null, "", "/admin");
        setError(e.response?.data?.detail || "Sign-in failed, please try again");
      });
  }, [location.hash, navigate]);

  if (!error) return null;
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="bg-white rounded-[28px] border-4 border-ink p-8 max-w-md text-center" data-testid="auth-error">
        <p className="font-display text-ink text-[24px] mb-3">Access denied</p>
        <p className="text-ink/70 mb-6">{error}</p>
        <a href="/admin" className="inline-flex bg-ink text-white px-6 py-3 rounded-full font-semibold" data-testid="auth-error-retry">
          Try another account
        </a>
      </div>
    </div>
  );
};
